import React, { useEffect, useRef } from 'react';
import { AccessDeniedIcon } from "../svgIcon";
import { Container, Row, Col} from "react-bootstrap";
const AccessDenied = () => {
    const sectionRef = useRef(null);
    useEffect(() => {
        sectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, []);

    return (
        <section ref={sectionRef} className='section-gap double-gap acc-denied-sec'>
            <Container>
                <Row className='justify-content-center'>
                    <Col lg={10} xs={12}>
                        <div className='text-center'>
                            <AccessDeniedIcon/>
                            <h4 className='mt-5'>The link you are trying to access is no longer exist.</h4>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default AccessDenied;